export class DeheadingRatesRequest{
    deheadingRatesId:number
    contractorName:string;
    count:string;
    billType:string;
    rate:string;
   
    constructor(
        deheadingRatesId:number,
        contractorName:string,
        count:string,
        billType:string,
        rate:string
    ){
       this.deheadingRatesId = deheadingRatesId
       this.contractorName = contractorName
       this.count = count
       this.billType= billType
       this.rate= rate
    }
}
export class DeheadingRatesRequestDto{
    data:DeheadingRatesRequest[]
    user:string
    constructor(
        data:DeheadingRatesRequest[],
        user:string 
    )
    {
        this.data = data
        this.user = user
    }
}